module.exports = __webpack_public_path__ + "media/a_flutter_on_the_wind.cf4cbf80.mp3";